import {outlinedButton, purpleButton} from "assets/theme";
import ExportDialogStyle from "editor/components/dialogs/ExportDialog/ExportDialogStyle";

const PreviewDialogStyle = theme => ({
  ...ExportDialogStyle(theme),
});

export default PreviewDialogStyle;
